/* eslint-disable no-param-reassign */

/**
 * `selectionStart` and `selectionEnd` can only be used on specific input types.
 * @see https://html.spec.whatwg.org/#input-type-attr-summary
 */
const selectableInputTypes: Array<HTMLInputElement['type']> = [
  'text',
  'search',
  'url',
  'tel',
  'password',
]

function isSelectionSupported(type: string) {
  return selectableInputTypes.includes(type)
}

function setNativeValue(element: HTMLInputElement, value: string) {
  const propertyDescriptor = Object.getOwnPropertyDescriptor(
    window.HTMLInputElement.prototype,
    'value',
  )

  if (!propertyDescriptor?.set) {
    element.value = value

    return
  }

  propertyDescriptor.set.call(element, value)
}

/**
 * We use a dedicated function to set new input values for different reasons:
 *   1. The cursor position needs to be adjusted when the format of the value changes
 *   2. An onChange event needs to be triggered when the value changes.
 */
export function setValue(element: HTMLInputElement, value: string) {
  if (
    document.activeElement === element &&
    isSelectionSupported(element.type)
  ) {
    const caret =
      (element.selectionStart || 0) +
      Math.abs(value.length - element.value.length)

    window.requestAnimationFrame(() => {
      element.selectionStart = caret
      element.selectionEnd = caret
    })
  }

  setNativeValue(element, value)
}
